var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgAudioIcon = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 23,
    viewBox: "0 0 31 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.14917,
    y: 5.755,
    width: 2.11225,
    height: 11.0438,
    rx: 1.05612,
    fill: "#4D6EF5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.57471,
    y: 7.9325,
    width: 2.11225,
    height: 6.68831,
    rx: 1.05612,
    fill: "#4D6EF5"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 9,
    width: 2.11225,
    height: 4.19944,
    rx: 1.05612,
    fill: "#4D6EF5"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 13.7239,
    width: 2.11225,
    height: 22.5538,
    rx: 1.05612,
    fill: "#4D6EF5"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 22.9858,
    y: 7.52063,
    width: 2.11225,
    height: 6.68831,
    rx: 1.05612,
    fill: "#4D6EF5"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 17.9858,
    y: 5.52063,
    width: 2.11225,
    height: 11.0438,
    rx: 1.05612,
    fill: "#4D6EF5"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 27.9858,
    y: 9,
    width: 2.11225,
    height: 4.19944,
    rx: 1.05612,
    fill: "#4D6EF5"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAudioIcon);
export default ForwardRef;